<ng-template #modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modalConfig.modalTitle }}</h5>
    <button (click)="topClose()"
            *ngIf="modalConfig.hideTopCloseButton === undefined || !modalConfig.hideTopCloseButton()"
            class="text-end btn btn-primary"
            type="button">
      <i class="feather icon-x" style="color:white;font-size:20px;"></i>
    </button>
  </div>
  <div class="modal-body" [style]="modalConfig.css">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <button (click)="dismiss()"
            *ngIf="modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()"
            [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()"
            class="btn btn-outline-secondary"
            type="button">
      {{ modalConfig.dismissButtonLabel }}
    </button>
    <button (click)="close()"
            *ngIf="modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()"
            [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()"
            class="btn btn-outline-primary"
            type="button">
      {{ modalConfig.closeButtonLabel }}
    </button>
  </div>
</ng-template>
